import axios from 'axios'
import { getAuthHeaders } from '../../lib/session'

// const API = process.env.REACT_APP_API_URL_LOCAL
const API = process.env.REACT_APP_API_URL

const getConfig = async () => {
  try {
    const headers = await getAuthHeaders()
    return { headers }
  } catch (error) {
    // If we can't get a valid session, throw an error
    throw new Error('Unauthorized')
  }
}

const getApi = baseUrl => ({
  getAccountNumber: () => {
    const user = JSON.parse(localStorage.getItem('user'))
    return user ? user.accountId : null
  },

  getResource: async (name, query = {}) => {
    const queryString =
      typeof query === 'object'
        ? Object.keys(query)
            .map(key => `${key}=${query[key]}`)
            .join('&')
        : query

    try {
      let url = `${baseUrl}/${name}`
      url = queryString ? `${url}?${queryString}` : url
      const { data } = await axios.get(url, await getConfig())
      if (data.data) return data.data
      return data
    } catch (err) {
      console.log(err)
      throw err
    }
  },

  postResource: async (name, body) => {
    try {
      const { data } = await axios.post(`${baseUrl}/${name}`, body, await getConfig())
      return data.data
    } catch (err) {
      console.log(err)
      throw err
    }
  },

  putResource: async (name, body) => {
    try {
      const { data } = await axios.put(`${baseUrl}/${name}`, body, await getConfig())
      return data.data
    } catch (err) {
      console.log(err)
      throw err
    }
  },

  patchResource: async (name, body) => {
    try {
      const { data } = await axios.patch(`${baseUrl}/${name}`, body, await getConfig())
      return data.data
    } catch (err) {
      console.log(err)
      throw err
    }
  },

  postFormData: async (name, formData) => {
    try {
      const config = await getConfig()
      config.headers['Content-Type'] = 'multipart/form-data'

      const { data } = await axios.post(`${baseUrl}/${name}`, formData, config)
      return data.data
    } catch (err) {
      console.log(err)
      throw err
    }
  },

  deleteResource: async (name, query = '', data = {}) => {
    console.log(name)
    const config = await getConfig()
    try {
      await axios.delete(`${baseUrl}/${name}?${query}`, { ...config, data })
      return 'success'
    } catch (err) {
      console.log(err)
      throw err
    }
  },
})

export default getApi(API)
